import React from 'react';
import { getUserName, isSameUser } from '../utils/userUtils';

export default function DiscussionThread({
  comments = [],
  commentInput = "",
  onCommentInputChange,
  onAddComment,
  onDeleteComment,
  placeholder = "Comment on this...",
  users = [],
  isExpanded = false
}) {
  const isMyComment = (user) => {
    const currentLoggedUser = localStorage.getItem("dayones_user_name") || "";
    return isSameUser(users, user, currentLoggedUser);
  };

  if (!isExpanded) return null;

  return (
    <div style={{ borderTop: '1px solid var(--color-glass-border)', paddingTop: '12px' }}>
      <span style={{ fontSize: '0.7rem', fontWeight: '600', textTransform: 'uppercase', color: 'var(--color-text-muted)', display: 'block', marginBottom: '8px' }}>Discussions</span>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '150px', overflowY: 'auto', marginBottom: '12px' }}>
        {!comments || comments.length === 0 ? (
          <span style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)', fontStyle: 'italic' }}>No discussions yet.</span>
        ) : (
          comments.map(c => (
            <div key={c.id} className="comment-box" style={{ padding: '8px 12px', background: 'rgba(252, 249, 245,0.01)', border: '1px solid var(--color-glass-border)', borderRadius: '0px', position: 'relative' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.7rem', color: 'var(--color-secondary)', fontWeight: '600', marginBottom: '2px' }}>
                <span>{getUserName(users, c.user)}</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ color: 'var(--color-text-muted)' }}>{c.time}</span>
                  {isMyComment(c.user) && (
                    <button
                      onClick={() => onDeleteComment(c.id)}
                      className="btn-inline-delete-cross"
                      style={{ lineHeight: 1 }}
                      title="Delete Comment"
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>
              <p style={{ fontSize: '0.8rem', color: 'var(--color-text-main)', lineHeight: '1.4', paddingRight: '16px', margin: 0, textAlign: 'left' }}>{c.text}</p>
            </div>
          ))
        )}
      </div>

      <div style={{ display: 'flex', gap: '8px' }}>
        <input
          type="text"
          placeholder={placeholder}
          className="input-field"
          style={{ padding: '6px 10px', fontSize: '0.75rem', flex: 1, minWidth: 0 }}
          value={commentInput}
          onChange={e => onCommentInputChange(e.target.value)}
          onKeyPress={e => e.key === 'Enter' && onAddComment()}
        />
        <button className="btn-secondary" style={{ padding: '6px 10px', fontSize: '0.75rem' }} onClick={onAddComment}>Post</button>
      </div>
    </div>
  );
}
